/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UniversalPresetHitSchema {
  id: string;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 50 */
  preset_type: string;
  description?: string | null;
}
